import { DEFAULT_CONFIGURATION_ID } from 'formInitialValues'
import { getDefaultAffiliateId, getClientUuid } from 'utils/url'

export const formFilledJson = {
  data: {
    system: {
      advertisementId: DEFAULT_CONFIGURATION_ID,
      configurationId: DEFAULT_CONFIGURATION_ID,
      affiliateId: getDefaultAffiliateId(),
      clientUuid: getClientUuid()
    },
    common: {
      amount: 30000,
      term: 84,
      purpose: 'OTHER',
      payoutAccount: {
        type: 'IBAN_BIC',
        country: 'DE',
        iban: 'DE02120300000000202051'
      },
      salaryAccount: {},
      loanPayout: 'AS_SOON_AS_POSSIBLE',
      payoutAccountHolder: 'PRIMARY',
      rateDueOn: 1,
      vehicle: {
        type: 'CAR',
        powerUnit: 'PS',
        price: 20000
      },
      rdi: {
        isSecondaryDebtorIncluded: true,
        hasAcceptedConsultation: true,
        type: 'NONE'
      },
      hasAcceptedTerms: true
    },
    debtors: {
      count: 1,
      isSameContactInformation: true,
      isCommonHousehold: true,
      isSameAddress: true,
      primary: {
        contact: {
          phoneNumber: '+4940123123',
          email: 'dasd@gmail.com'
        },
        residentAlien: {
          isResidencePermitTemporary: false,
          isWorkPermitTemporary: false
        },
        hasMinijob: false,
        activeLoans: null,
        numberOfActiveLoans: 0,
        hasPreviousEmployment: false,
        personal: {
          nationality: 'DE',
          countryOfBirth: 'DE',
          civilStatus: 'SINGLE',
          gender: 'MALE',
          firstname: 'Jan',
          lastname: 'nac',
          birthday: '1990-10-01',
          birthplace: 'berlin'
        },
        pensionFund: {
          address: {
            country: 'DE'
          },
          name: ''
        },
        household: {
          livingSituation: 'RENTING',
          numberOfResidents: 1,
          numberOfChildren: 0
        },
        realEstate: {
          rentalProperty: {
            type: 'APPARTMENT',
            size: 55
          },
          selfUsedProperty: {}
        },
        previousEmployment: {
          isGermanSalaryAccount: true,
          employer: {
            address: {
              country: 'DE'
            },
            name: ''
          },
          selfEmployment: {
            address: {}
          }
        },
        currentEmployment: {
          position: 'EMPLOYEE',
          workingTime: 'FULL_TIME',
          isTemporary: false,
          isExtended: false,
          isInProbationPeriod: false,
          isGermanSalaryAccount: true,
          employer: {
            address: {
              country: 'DE',
              city: 'Berlin',
              street: 'Palisadenstr.',
              houseNumber: '90',
              zipCode: '10243'
            },
            name: 'smava Bigwave GmbH'
          },
          selfEmployment: {
            isDoubleBookkeepingRequired: false,
            address: {
              country: 'DE'
            }
          },
          isIncomeProvable: true,
          since: '2014-10-01',
          sector: 'BANK'
        },
        currentAddress: {
          country: 'DE',
          city: 'Berlin',
          zipCode: '11011',
          street: 'Str ',
          houseNumber: '22'
        },
        previousAddress: {
          country: 'DE'
        },
        income: {
          spousalSupport: 0,
          pension: 0,
          pensions: null,
          childSupport: 0,
          hasFurtherIncome: false,
          isPrimaryIncomeStable: true,
          numberOfChildrenWithChildBenefits: 0,
          secondaryEmployments: null,
          numberOfSecondaryEmployments: 0,
          interest: 0,
          numberOfPensions: 0,
          numberOfChildrenWithChildSupport: 0,
          primary: 30000
        },
        expenses: {
          cards: 'DEBITCARD_CREDITCARD',
          homePurchaseSavingsRate: 0,
          lifeInsurance: 0,
          privateHealthInsuranceRate: 0,
          spousalSupport: 0,
          childSupport: 0,
          numberOfChildrenWithChildSupport: 0,
          hasCar: false,
          mortgageRateUsedProperty: 0,
          mortgageRateRentalProperty: 0,
          additionalHousingCosts: 0,
          isHomePurchaseSavingsUsedForMortgageRepayment: false,
          isLifeInsuranceUsedForMortgageRepayment: false,
          rent: 750
        },
        personId: '44d93f6b-e558-419b-8203-aba7ff4702b9',
        temporary: {
          residentSince: {
            year: '2000'
          }
        },
        residentSince: '2000-01-01'
      },
      secondary: {
        residentAlien: {
          isResidencePermitTemporary: false,
          isWorkPermitTemporary: false
        },
        pensionFund: {
          address: {
            country: 'DE'
          },
          name: ''
        },
        hasMinijob: false,
        activeLoans: null,
        numberOfActiveLoans: 0,
        hasPreviousEmployment: false,
        income: {
          spousalSupport: 0,
          pension: 0,
          pensions: null,
          numberOfPensions: 0,
          childSupport: 0,
          hasFurtherIncome: false,
          isPrimaryIncomeStable: true,
          secondaryEmployments: null,
          numberOfSecondaryEmployments: 0,
          numberOfChildrenWithChildBenefits: 0,
          interest: 0,
          numberOfChildrenWithChildSupport: 0
        },
        realEstate: {
          rentalProperty: {
            type: 'NONE'
          },
          selfUsedProperty: {}
        },
        expenses: {
          cards: 'DEBITCARD_CREDITCARD',
          homePurchaseSavingsRate: 0,
          lifeInsurance: 0,
          privateHealthInsuranceRate: 0,
          spousalSupport: 0,
          childSupport: 0,
          numberOfChildrenWithChildSupport: 0,
          hasCar: false,
          hasBike: false,
          mortgageRateUsedProperty: 0,
          mortgageRateRentalProperty: 0,
          additionalHousingCosts: 0,
          isHomePurchaseSavingsUsedForMortgageRepayment: false,
          isLifeInsuranceUsedForMortgageRepayment: false
        },
        personal: {
          countryOfBirth: 'DE',
          nationality: 'DE',
          civilStatus: 'SINGLE'
        },
        household: {
          numberOfResidents: 1,
          numberOfChildren: 0
        },
        previousEmployment: {
          isGermanSalaryAccount: true,
          employer: {
            address: {
              country: 'DE'
            },
            name: ''
          },
          selfEmployment: {
            address: {}
          }
        },
        currentEmployment: {
          position: 'EMPLOYEE',
          workingTime: 'FULL_TIME',
          isTemporary: false,
          isExtended: false,
          isInProbationPeriod: false,
          isGermanSalaryAccount: true,
          employer: {
            address: {
              country: 'DE'
            }
          },
          selfEmployment: {
            isDoubleBookkeepingRequired: false,
            address: {
              country: 'DE'
            }
          },
          isIncomeProvable: true
        },
        currentAddress: {
          country: 'DE'
        },
        previousAddress: {
          country: 'DE'
        },
        contact: {}
      }
    },
    policyLoans: {
      loans: null
    }
  }
}
